export default __webpack_public_path__ + "img/ddd02eb18cbd462bcc23f51db2865f07.svg";